export const PALLET_STOCK_REPORT_REQUEST = 'PALLET_STOCK_REPORT_REQUEST';
export const PALLET_STOCK_REPORT_SUCCESS = 'PALLET_STOCK_REPORT_SUCCESS';
export const PALLET_STOCK_REPORT_FAILURE = 'PALLET_STOCK_REPORT_FAILURE';
export const PALLET_STOCK_FILTER_REPORT_REQUEST = 'PALLET_STOCK_FILTER_REPORT_REQUEST';
export const PALLET_STOCK_FILTER_REPORT_SUCCESS = 'PALLET_STOCK_FILTER_REPORT_SUCCESS';
export const PALLET_STOCK_FILTER_REPORT_FAILURE = 'PALLET_STOCK_FILTER_REPORT_FAILURE';